<template>
	<div class="gf-popup">
		<div class="inner-pop">
			<button @click="closeMe" class="close-btn">
				<span>Lukk</span>
				<svg width="50" height="50" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg">
					<defs />
					<path
						d="M25 0C11.188 0 0 11.188 0 25s11.188 25 25 25 25-11.187 25-25S38.813 0 25 0zm12.5 33.963L33.963 37.5 25 28.538 16.037 37.5 12.5 33.963 21.462 25 12.5 16.037l3.537-3.537L25 21.462l8.963-8.962 3.537 3.537L28.538 25l8.962 8.963z"
						fill="#485157"
						fill-rule="nonzero"
					/>
				</svg>
			</button>
			<div class="content">
				<h2 v-if="title" class="form-title" v-html="title"></h2>
				<div v-if="content" class="form-desc" v-html="content"></div>
				<div class="content-inner-form" ref="content" v-once>
					<Preloader />
				</div>
			</div>
		</div>
		<div class="overlay" @click="closeMe()"></div>
	</div>
</template>

<script>
import Preloader from '@/components/elements/Preloader'

export default {
	name: 'gravity-form-popup',
	props: {
		fields: Object,
		form: {
			type: Number,
			default: 1,
		},
		title: {
			type: String,
			default: '',
		},
		content: {
			type: String,
			default: '',
		},
	},
	components: {
		Preloader,
	},
	mounted() {
		document.getElementsByTagName('html')[0].classList.add('popup-open')
		const content = this.$refs.content
		if (this.form && content) {
			this.loadGravityForm2(this.form, content)
		}
	},
	destroyed() {
		document.getElementsByTagName('html')[0].classList.remove('popup-open')
	},
	methods: {
		closeMe() {
			this.$emit('close', true)
		},
		loadGravityForm2(formId, content) {
			const apiUrl = window.WPVUE.home.replace(/\/$/, '') + '/' + window.WPVUE.ajaxurl
			const VM = this
			return window.axios
				.get(apiUrl, {
					params: {
						action: 'gf_button_get_form',
						form_id: formId,
						...this.fields,
					},
				})
				.then((res) => {
					if (typeof window['gformInitDatepicker'] !== 'undefined') {
						window.gformInitDatepicker()
					}
					if (content) {
						window.jQuery(content).html(res.data)
					}
					return res
				})
		},
	},
	computed: {},
}
</script>

<style lang="scss">
@import '@/assets/vars.scss';
@import '@/assets/mixins.scss';
.gf-popup {
	z-index: 999;
	position: fixed;
	top: 0;
	left: 0;
	bottom: 0;
	right: 0;
	display: flex;
	justify-content: center;
	align-items: center;
	.form-title {
		margin-top: 0;
	}
	.content-inner-form {
		.gform_heading {
			display: none;
		}
	}
	.inner-pop {
		text-align: left;
		background: var(--light);
		box-shadow: 0 0 20px 0 rgba(72, 81, 87, 0.2);
		padding: 100px;
		position: relative;
		z-index: 20;
		max-width: 800px;
		width: 90%;
		max-height: 90%;
		overflow: auto;
		@include mquery($tablet) {
			padding: 70px;
			width: 95%;
			max-height: 95%;
		}
		@include mquery($phone) {
			padding: 50px 15px 30px;
		}

		.close-btn {
			cursor: pointer;
			background-color: transparent;
			position: absolute;
			top: 25px;
			right: 25px;
			z-index: 15;
			border: none;
			display: flex;
			align-items: center;
			color: var(--dark);
			@include fluid-type($smallResText, $wideResText, 14px, 18px);
			svg {
				margin-left: 15px;
			}
			svg {
				path {
					@include transition(fill, 150ms);
				}
			}
			&:hover {
				svg {
					path {
						fill: $red;
					}
				}
			}
		}
	}
	.overlay {
		cursor: pointer;
		background-color: rgba(#fff, 0.5);
		position: absolute;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
		z-index: 10;
	}
}
</style>
